export default {
      id: "progress-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#progress-usage",
      toString: function () {
        return this.url;
      }
    }